import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { colors } from 'common/styles/style-constants';
import { Icon } from 'opencare-crown';

export const RadioIcon = styled(Icon)`
  && {
    vertical-align: 0.1em;
  }

  margin-right: 5px;

  & > svg {
    height: 12px;
  }
`;

export const MatchesLink = styled(Link)`
  margin: 0 0 0 auto;
  flex: 0 0 auto;

  &:hover {
    text-decoration: underline;
    color: ${colors.slate};
  }
`;

export const SkipToContentButton = styled.button`
  background: none;
  border: none;
  color: ${colors.darkBlue};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -100%);
  z-index: -1;

  &:focus {
    transform: translate(-50%, 25%);
    z-index: 1;
  }
`;
